import {isIOS, isAndroid} from 'react-device-detect';

function promoApply(promo,deliFee,total,cartList, shopList, delivery) {

    //const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

    const promoDiscount = (promoType, promoValue,whatTotal,whatFee, shopName, distance) => {
        let newState = shopList;
        let discount = 0;
        let index = newState.findIndex(arg => arg.Seller === shopName)
        //localStorage.setItem('BimBimPromotion', 0)
       
        if (promoType === 'FreeDeli')  discount = Number(whatFee)
        if (promoType === '%Discount') discount = whatTotal*Number(promoValue)
        if (promoType === '$Discount') discount = Number(promoValue)

        if (distance) {
            if (Number(newState[index].Distance) > Number(distance)) discount = 0
        }

        if (shopName) newState[index].Promo = discount
        if (shopName === '')  localStorage.setItem('BimBimPromotion', discount)
        
        return newState
    }

    const promoCond = (whatPromo,totalItem) => {
        if (
            (whatPromo['Require'].Type === 'AmountEqual' && totalItem === Number(whatPromo['Require'].Value))
            || (whatPromo['Require'].Type === 'AmountAtLeast' && totalItem >= Number(whatPromo['Require'].Value))
        )  return promoDiscount(whatPromo.Type, whatPromo.Value,total, deliFee, '', whatPromo.Distance)
        
        if (
            whatPromo['Require'].Type === 'TotalAtLeast' && (Number(total) - Number(deliFee)) >= Number(whatPromo['Require'].Value)
        ) return promoDiscount(whatPromo.Type, whatPromo.Value,total, deliFee, '', whatPromo.Distance)
    }

    const promoShopCond = (whatPromo,totalItem, fee, shopIndex) => {
        if (
            (whatPromo['Require'].Type === 'AmountEqual' && totalItem === Number(whatPromo['Require'].Value))
            || (whatPromo['Require'].Type === 'AmountAtLeast' && totalItem >= Number(whatPromo['Require'].Value))
            )  return promoDiscount(whatPromo.Type, whatPromo.Value, whatPromo.shopTotal,fee, shopList[shopIndex].Seller, whatPromo.Distance)

            if (
                whatPromo['Require'].Type === 'TotalAtLeast' && (Number(shopList[shopIndex].shopTotal)) >= Number(whatPromo['Require'].Value)
            ) return promoDiscount(whatPromo.Type, whatPromo.Value, shopList[shopIndex].shopTotal,fee, shopList[shopIndex].Seller, whatPromo.Distance)
    }

    const excutePromo = (i) => {
        if (promo[i]['Require']){
            let totalItem = 0;
            for (let items in cartList){
                for (let item in items) {
                    if (cartList[items][item]) totalItem = totalItem + Number(cartList[items][item].Amount)
                }
            }

            if ((promo[i]['Require'].WhatPlat) && promo[i]['Require'].WhatPlat === 'App'){
                if (isIOS || isAndroid){
                    const isInStandaloneMode = () =>
                        (window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://');
                    if (isInStandaloneMode()) return promoCond(promo[i], totalItem)
                }
            }
            else return promoCond(promo[i], totalItem)

        }
        else return promoDiscount(promo[i].Type, promo[i].Value,total, deliFee, '', promo[i].Distance)
    }

    for (let i in promo){
        if (promo[i]) {
            if (promo[i].Shop) {
                for (let shopIndex in shopList){
                    if (promo[i].Shop === shopList[shopIndex].Seller){
                        const items = shopList[shopIndex].Seller
                        let fee = Number(delivery.find(arg => arg.name === items).fee)
                        if (promo[i]['Require']){
                            let totalItem = 0;
                            for (let item in cartList[items]) {
                                if (cartList[items][item]) totalItem = totalItem + Number(cartList[items][item].Amount)
                                }
                            
                            if ((promo[i]['Require'].WhatPlat) && promo[i]['Require'].WhatPlat === 'App'){
                                if (isIOS || isAndroid) {
                                    const isInStandaloneMode = () =>
                                    (window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://');
                                    if (isInStandaloneMode()) return promoShopCond(promo[i], totalItem, fee, shopIndex)                            
                                }
                            }
                            else return promoShopCond(promo[i], totalItem, fee, shopIndex)
        
                        }
                        else return promoDiscount(promo[i].Type, promo[i].Value, shopList[shopIndex].shopTotal,fee, items, promo[i].Distance)
                        break;
                    }
                }
            }    
            else return excutePromo(i)
        }
    }
}

export default promoApply